import { styled } from '@mui/material/styles';

const TooltipDiv = styled('div')(({ theme }) => ({
    backgroundColor: 'white',
    borderRadius: 5,
    padding: '6px 10px 6px 10px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
}));

export default TooltipDiv;